import React, { useState } from "react";
import {
  Box,
  Button,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  TablePagination,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Grid,
  InputAdornment,
  Chip,
  Tooltip,
  Alert,
  Card,
  CardContent,
  Avatar,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Tabs,
  Tab,
  LinearProgress,
  Divider,
  FormControl,
  InputLabel,
  Select,
  Badge,
} from "@mui/material";
import {
  Search as SearchIcon,
  Refresh as RefreshIcon,
  SupervisorAccount as PartnerIcon,
  Visibility as ViewIcon,
  Edit as EditIcon,
  Block as BlockIcon,
  CheckCircle as ActivateIcon,
  Delete as DeleteIcon,
  MoreVert as MoreIcon,
  Business as BusinessIcon,
  TrendingUp as SalesIcon,
  AttachMoney as CommissionIcon,
  VerifiedUser as VerifiedIcon,
  HourglassEmpty as PendingIcon,
  Star as StarIcon,
  Phone as PhoneIcon,
  Email as EmailIcon,
  LocationOn as LocationIcon,
  CalendarToday as CalendarIcon,
  Assessment as PerformanceIcon,
  AccountBalance as BankIcon,
  Person as OwnerIcon,
  Download as ExportIcon,
  FilterList as FilterIcon,
  Payment as PaymentIcon,
  Info as InfoIcon,
} from "@mui/icons-material";

const PartnerList = () => {
  const [activeTab, setActiveTab] = useState(0);
  
  // Sample partners data with enhanced details
  const [partners, setPartners] = useState([
    {
      id: 1,
      partnerCode: "PTR001",
      partnerName: "Suresh Enterprises",
      ownerName: "Suresh Kumar",
      partnerType: "Reseller",
      phone: "+91 98765 43210",
      email: "suresh@enterprises.com",
      city: "Mumbai",
      state: "Maharashtra",
      sponsorCode: "PTR000",
      sponsorName: "Direct",
      commissionPlan: "Standard - 10%",
      commissionRate: 10,
      totalSales: 850000,
      monthlySales: 125000,
      totalCommission: 85000,
      paidCommission: 73000,
      outstandingCommission: 12000,
      activeCustomers: 45,
      totalOrders: 128,
      avgOrderValue: 6640,
      kycStatus: "Verified",
      status: "Active",
      registrationDate: "2023-06-15",
      lastActivityDate: "2024-01-18",
      rating: 4.5,
      bankVerified: true,
      gstNumber: "27AAAAA0000A1Z5",
    },
    {
      id: 2,
      partnerCode: "PTR002",
      partnerName: "Tech Solutions Hub",
      ownerName: "Priya Sharma",
      partnerType: "Affiliate",
      phone: "+91 98765 43211",
      email: "priya@techsolutions.com",
      city: "Bangalore",
      state: "Karnataka",
      sponsorCode: "PTR001",
      sponsorName: "Suresh Enterprises",
      commissionPlan: "Affiliate - 5%",
      commissionRate: 5,
      totalSales: 450000,
      monthlySales: 68000,
      totalCommission: 22500,
      paidCommission: 17500,
      outstandingCommission: 5000,
      activeCustomers: 28,
      totalOrders: 76,
      avgOrderValue: 5920,
      kycStatus: "Pending",
      status: "Active",
      registrationDate: "2023-08-20",
      lastActivityDate: "2024-01-20",
      rating: 4.2,
      bankVerified: true,
      gstNumber: "29BBBBB0000B1Z5",
    },
    {
      id: 3,
      partnerCode: "PTR003",
      partnerName: "Digital Commerce Pro",
      ownerName: "Amit Patel",
      partnerType: "Distributor",
      phone: "+91 98765 43212",
      email: "amit@digitalcommerce.com",
      city: "Ahmedabad",
      state: "Gujarat",
      sponsorCode: "PTR000",
      sponsorName: "Direct",
      commissionPlan: "Distributor - 15%",
      commissionRate: 15,
      totalSales: 1250000,
      monthlySales: 245000,
      totalCommission: 187500,
      paidCommission: 152500,
      outstandingCommission: 35000,
      activeCustomers: 92,
      totalOrders: 245,
      avgOrderValue: 5100,
      kycStatus: "Verified",
      status: "Active",
      registrationDate: "2023-05-10",
      lastActivityDate: "2024-01-19",
      rating: 4.8,
      bankVerified: true,
      gstNumber: "24CCCCC0000C1Z5",
    },
    {
      id: 4,
      partnerCode: "PTR004",
      partnerName: "Retail Connect",
      ownerName: "Sneha Desai",
      partnerType: "Reseller",
      phone: "+91 98765 43213",
      email: "sneha@retailconnect.com",
      city: "Pune",
      state: "Maharashtra",
      sponsorCode: "PTR003",
      sponsorName: "Digital Commerce Pro",
      commissionPlan: "Standard - 10%",
      commissionRate: 10,
      totalSales: 320000,
      monthlySales: 52000,
      totalCommission: 32000,
      paidCommission: 24000,
      outstandingCommission: 8000,
      activeCustomers: 22,
      totalOrders: 58,
      avgOrderValue: 5517,
      kycStatus: "Verified",
      status: "Active",
      registrationDate: "2023-09-15",
      lastActivityDate: "2024-01-15",
      rating: 4.0,
      bankVerified: true,
      gstNumber: "27DDDDD0000D1Z5",
    },
    {
      id: 5,
      partnerCode: "PTR005",
      partnerName: "Sales Force India",
      ownerName: "Vikram Singh",
      partnerType: "Agent",
      phone: "+91 98765 43214",
      email: "vikram@salesforce.com",
      city: "Delhi",
      state: "Delhi",
      sponsorCode: "PTR001",
      sponsorName: "Suresh Enterprises",
      commissionPlan: "Agent - 7%",
      commissionRate: 7,
      totalSales: 180000,
      monthlySales: 28000,
      totalCommission: 12600,
      paidCommission: 10000,
      outstandingCommission: 2600,
      activeCustomers: 15,
      totalOrders: 34,
      avgOrderValue: 5294,
      kycStatus: "Pending",
      status: "Pending Approval",
      registrationDate: "2024-01-10",
      lastActivityDate: "2024-01-20",
      rating: 3.8,
      bankVerified: false,
      gstNumber: "",
    },
    {
      id: 6,
      partnerCode: "PTR006",
      partnerName: "Global Retail Partners",
      ownerName: "Rahul Mehta",
      partnerType: "Distributor",
      phone: "+91 98765 43215",
      email: "rahul@globalretail.com",
      city: "Chennai",
      state: "Tamil Nadu",
      sponsorCode: "PTR000",
      sponsorName: "Direct",
      commissionPlan: "Distributor - 15%",
      commissionRate: 15,
      totalSales: 980000,
      monthlySales: 165000,
      totalCommission: 147000,
      paidCommission: 140000,
      outstandingCommission: 7000,
      activeCustomers: 68,
      totalOrders: 187,
      avgOrderValue: 5240,
      kycStatus: "Verified",
      status: "Active",
      registrationDate: "2023-07-05",
      lastActivityDate: "2024-01-17",
      rating: 4.6,
      bankVerified: true,
      gstNumber: "33EEEEE0000E1Z5",
    },
    {
      id: 7,
      partnerCode: "PTR007",
      partnerName: "Quick Commerce Ltd",
      ownerName: "Neha Kapoor",
      partnerType: "Reseller",
      phone: "+91 98765 43216",
      email: "neha@quickcommerce.com",
      city: "Jaipur",
      state: "Rajasthan",
      sponsorCode: "PTR003",
      sponsorName: "Digital Commerce Pro",
      commissionPlan: "Standard - 10%",
      commissionRate: 10,
      totalSales: 156000,
      monthlySales: 32000,
      totalCommission: 15600,
      paidCommission: 15600,
      outstandingCommission: 0,
      activeCustomers: 12,
      totalOrders: 28,
      avgOrderValue: 5571,
      kycStatus: "Verified",
      status: "Inactive",
      registrationDate: "2023-10-20",
      lastActivityDate: "2023-12-05",
      rating: 3.5,
      bankVerified: true,
      gstNumber: "08FFFFF0000F1Z5",
    },
  ]);

  const [searchQuery, setSearchQuery] = useState("");
  const [statusFilter, setStatusFilter] = useState("all");
  const [typeFilter, setTypeFilter] = useState("all");
  const [kycFilter, setKycFilter] = useState("all");
  const [performanceFilter, setPerformanceFilter] = useState("all");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [successMessage, setSuccessMessage] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedPartner, setSelectedPartner] = useState(null);
  const [viewingPartner, setViewingPartner] = useState(null);
  const [openViewModal, setOpenViewModal] = useState(false);

  // Helper functions
  const getFilteredPartners = () => {
    let filtered = partners;

    // Search filter
    if (searchQuery) {
      filtered = filtered.filter((partner) =>
        Object.values(partner).some((value) =>
          String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
      );
    }

    // Status filter
    if (statusFilter !== "all") {
      filtered = filtered.filter((p) => p.status === statusFilter);
    }

    // Type filter
    if (typeFilter !== "all") {
      filtered = filtered.filter((p) => p.partnerType === typeFilter);
    }

    // KYC filter
    if (kycFilter !== "all") {
      filtered = filtered.filter((p) => p.kycStatus === kycFilter);
    }

    // Performance filter
    if (performanceFilter === "high") {
      filtered = filtered.filter((p) => p.totalSales >= 500000);
    } else if (performanceFilter === "medium") {
      filtered = filtered.filter((p) => p.totalSales >= 200000 && p.totalSales < 500000);
    } else if (performanceFilter === "low") {
      filtered = filtered.filter((p) => p.totalSales < 200000);
    }

    // Tab filter
    if (activeTab === 1) {
      filtered = filtered.filter((p) => p.status === "Active");
    } else if (activeTab === 2) {
      filtered = filtered.filter((p) => p.status === "Pending Approval");
    } else if (activeTab === 3) {
      filtered = filtered.filter((p) => p.status === "Inactive");
    }

    return filtered;
  };

  const getTypeColor = (type) => {
    switch (type) {
      case 'Distributor': return 'primary';
      case 'Reseller': return 'secondary';
      case 'Affiliate': return 'info';
      case 'Agent': return 'warning';
      default: return 'default';
    }
  };

  const getKYCColor = (status) => {
    switch (status) {
      case 'Verified': return { bg: '#e8f5e9', color: '#2e7d32' };
      case 'Pending': return { bg: '#fff3e0', color: '#e65100' };
      case 'Rejected': return { bg: '#ffebee', color: '#d32f2f' };
      default: return { bg: '#f5f5f5', color: '#666' };
    }
  };

  const getPerformanceLevel = (sales) => {
    if (sales >= 500000) return { label: 'High', color: 'success' };
    if (sales >= 200000) return { label: 'Medium', color: 'warning' };
    return { label: 'Low', color: 'error' };
  };

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      maximumFractionDigits: 0,
    }).format(amount);
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('en-IN', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
    });
  };

  // Handlers
  const handleMenuOpen = (event, partner) => {
    setAnchorEl(event.currentTarget);
    setSelectedPartner(partner);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedPartner(null);
  };

  const handleView = (partner) => {
    setViewingPartner(partner);
    setOpenViewModal(true);
    handleMenuClose();
  };

  const handleActivate = (partner) => {
    setPartners(partners.map(p => 
      p.id === partner.id ? { ...p, status: 'Active' } : p
    ));
    setSuccessMessage(`${partner.partnerName} activated successfully!`);
    setTimeout(() => setSuccessMessage(""), 3000);
    handleMenuClose();
  };

  const handleDeactivate = (partner) => {
    setPartners(partners.map(p => 
      p.id === partner.id ? { ...p, status: 'Inactive' } : p
    ));
    setSuccessMessage(`${partner.partnerName} deactivated successfully!`);
    setTimeout(() => setSuccessMessage(""), 3000);
    handleMenuClose();
  };

  const handleDelete = (partner) => {
    if (window.confirm(`Are you sure you want to delete ${partner.partnerName}?`)) {
      setPartners(partners.filter(p => p.id !== partner.id));
      setSuccessMessage(`${partner.partnerName} deleted successfully!`);
      setTimeout(() => setSuccessMessage(""), 3000);
    }
    handleMenuClose();
  };

  const handleChangePage = (_, newPage) => setPage(newPage);
  
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleSearch = () => {
    setPage(0);
    setSuccessMessage(`Search completed. Found ${getFilteredPartners().length} partners.`);
    setTimeout(() => setSuccessMessage(""), 3000);
  };

  const handleReset = () => {
    setSearchQuery("");
    setStatusFilter("all");
    setTypeFilter("all");
    setKycFilter("all");
    setPerformanceFilter("all");
    setPage(0);
    setSuccessMessage("");
  };

  const handleExport = () => {
    setSuccessMessage("Partner list exported successfully!");
    setTimeout(() => setSuccessMessage(""), 3000);
  };

  const filteredPartners = getFilteredPartners();

  // Calculate statistics
  const totalPartners = partners.length;
  const activePartners = partners.filter(p => p.status === "Active").length;
  const totalSales = partners.reduce((sum, p) => sum + p.totalSales, 0);
  const totalCommission = partners.reduce((sum, p) => sum + p.totalCommission, 0);
  const totalOutstanding = partners.reduce((sum, p) => sum + p.outstandingCommission, 0);
  const verifiedPartners = partners.filter(p => p.kycStatus === "Verified").length;

  return (
    <Box sx={{ p: 3 }}>
      {/* Header Section */}
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <PartnerIcon sx={{ color: 'primary.main', fontSize: 40 }} />
          <Box>
            <Typography variant="h4" fontWeight="bold" color="primary">
              Partner List
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Complete partner directory with performance tracking • {filteredPartners.length} partners
            </Typography>
          </Box>
        </Box>
        <Box sx={{ display: 'flex', gap: 2 }}>
          <Button
            variant="outlined"
            startIcon={<ExportIcon />}
            onClick={handleExport}
            sx={{ borderRadius: 2 }}
          >
            Export
          </Button>
          <Button
            variant="outlined"
            startIcon={<FilterIcon />}
            sx={{ borderRadius: 2 }}
          >
            Advanced Filter
          </Button>
        </Box>
      </Box>

      {/* Success Message */}
      {successMessage && (
        <Alert severity="success" sx={{ mb: 2, borderRadius: 2 }}>
          {successMessage}
        </Alert>
      )}

      {/* Statistics Cards */}
      <Grid container spacing={3} sx={{ mb: 3 }}>
        <Grid item xs={12} sm={6} md={2.4}>
          <Card sx={{ borderRadius: 2, boxShadow: 2, borderLeft: '4px solid #1976d2' }}>
            <CardContent>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Box>
                  <Typography variant="caption" color="text.secondary">Total Partners</Typography>
                  <Typography variant="h4" fontWeight="bold" color="primary.main">
                    {totalPartners}
                  </Typography>
                </Box>
                <BusinessIcon sx={{ fontSize: 48, color: 'primary.main', opacity: 0.3 }} />
              </Box>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={2.4}>
          <Card sx={{ borderRadius: 2, boxShadow: 2, borderLeft: '4px solid #2e7d32' }}>
            <CardContent>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Box>
                  <Typography variant="caption" color="text.secondary">Active</Typography>
                  <Typography variant="h4" fontWeight="bold" color="success.main">
                    {activePartners}
                  </Typography>
                </Box>
                <ActivateIcon sx={{ fontSize: 48, color: 'success.main', opacity: 0.3 }} />
              </Box>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={2.4}>
          <Card sx={{ borderRadius: 2, boxShadow: 2, borderLeft: '4px solid #9c27b0' }}>
            <CardContent>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Box>
                  <Typography variant="caption" color="text.secondary">Total Sales</Typography>
                  <Typography variant="h6" fontWeight="bold" color="secondary.main">
                    {formatCurrency(totalSales)}
                  </Typography>
                </Box>
                <SalesIcon sx={{ fontSize: 48, color: 'secondary.main', opacity: 0.3 }} />
              </Box>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={2.4}>
          <Card sx={{ borderRadius: 2, boxShadow: 2, borderLeft: '4px solid #ff9800' }}>
            <CardContent>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Box>
                  <Typography variant="caption" color="text.secondary">Commission</Typography>
                  <Typography variant="h6" fontWeight="bold" color="warning.main">
                    {formatCurrency(totalCommission)}
                  </Typography>
                </Box>
                <CommissionIcon sx={{ fontSize: 48, color: 'warning.main', opacity: 0.3 }} />
              </Box>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={2.4}>
          <Card sx={{ borderRadius: 2, boxShadow: 2, borderLeft: '4px solid #d32f2f' }}>
            <CardContent>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Box>
                  <Typography variant="caption" color="text.secondary">Outstanding</Typography>
                  <Typography variant="h6" fontWeight="bold" color="error.main">
                    {formatCurrency(totalOutstanding)}
                  </Typography>
                </Box>
                <PaymentIcon sx={{ fontSize: 48, color: 'error.main', opacity: 0.3 }} />
              </Box>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      {/* Tabs */}
      <Paper sx={{ mb: 3, borderRadius: 2 }}>
        <Tabs 
          value={activeTab} 
          onChange={(e, newValue) => setActiveTab(newValue)}
          sx={{ borderBottom: 1, borderColor: 'divider' }}
        >
          <Tab 
            label={<Badge badgeContent={totalPartners} color="primary">All Partners</Badge>} 
            icon={<PartnerIcon />} 
            iconPosition="start" 
          />
          <Tab 
            label={<Badge badgeContent={activePartners} color="success">Active</Badge>} 
            icon={<ActivateIcon />} 
            iconPosition="start" 
          />
          <Tab 
            label={<Badge badgeContent={partners.filter(p => p.status === "Pending Approval").length} color="warning">Pending</Badge>} 
            icon={<PendingIcon />} 
            iconPosition="start" 
          />
          <Tab 
            label={<Badge badgeContent={partners.filter(p => p.status === "Inactive").length} color="error">Inactive</Badge>} 
            icon={<BlockIcon />} 
            iconPosition="start" 
          />
        </Tabs>
      </Paper>

      {/* Search and Filter Section */}
      <Paper sx={{ p: 3, mb: 3, borderRadius: 2, boxShadow: 2 }}>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} md={3}>
            <TextField
              fullWidth
              label="Search Partners..."
              variant="outlined"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid item xs={12} md={2}>
            <FormControl fullWidth>
              <InputLabel>Partner Type</InputLabel>
              <Select
                value={typeFilter}
                onChange={(e) => setTypeFilter(e.target.value)}
                label="Partner Type"
              >
                <MenuItem value="all">All Types</MenuItem>
                <MenuItem value="Distributor">Distributor</MenuItem>
                <MenuItem value="Reseller">Reseller</MenuItem>
                <MenuItem value="Affiliate">Affiliate</MenuItem>
                <MenuItem value="Agent">Agent</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={2}>
            <FormControl fullWidth>
              <InputLabel>KYC Status</InputLabel>
              <Select
                value={kycFilter}
                onChange={(e) => setKycFilter(e.target.value)}
                label="KYC Status"
              >
                <MenuItem value="all">All KYC</MenuItem>
                <MenuItem value="Verified">Verified</MenuItem>
                <MenuItem value="Pending">Pending</MenuItem>
                <MenuItem value="Rejected">Rejected</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={2}>
            <FormControl fullWidth>
              <InputLabel>Performance</InputLabel>
              <Select
                value={performanceFilter}
                onChange={(e) => setPerformanceFilter(e.target.value)}
                label="Performance"
              >
                <MenuItem value="all">All Performance</MenuItem>
                <MenuItem value="high">High (&gt; 5L)</MenuItem>
                <MenuItem value="medium">Medium (2-5L)</MenuItem>
                <MenuItem value="low">Low (&lt; 2L)</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={3}>
            <Box sx={{ display: 'flex', gap: 1 }}>
              <Button variant="contained" onClick={handleSearch} startIcon={<SearchIcon />} sx={{ flex: 1 }}>
                Search
              </Button>
              <Button variant="outlined" onClick={handleReset} startIcon={<RefreshIcon />} sx={{ flex: 1 }}>
                Reset
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Paper>

      {/* Table Section */}
      <Paper sx={{ borderRadius: 2, boxShadow: 3, overflow: 'hidden' }}>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow sx={{ backgroundColor: '#f8f9fa' }}>
                <TableCell sx={{ fontWeight: 'bold' }}>Partner Details</TableCell>
                <TableCell sx={{ fontWeight: 'bold' }}>Type</TableCell>
                <TableCell sx={{ fontWeight: 'bold' }}>Contact</TableCell>
                <TableCell sx={{ fontWeight: 'bold' }}>Sales Performance</TableCell>
                <TableCell sx={{ fontWeight: 'bold' }}>Commission</TableCell>
                <TableCell sx={{ fontWeight: 'bold' }}>KYC</TableCell>
                <TableCell sx={{ fontWeight: 'bold' }}>Rating</TableCell>
                <TableCell sx={{ fontWeight: 'bold' }}>Status</TableCell>
                <TableCell sx={{ fontWeight: 'bold' }} align="center">Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredPartners.length > 0 ? (
                filteredPartners.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((partner) => {
                  const kycStyle = getKYCColor(partner.kycStatus);
                  const performance = getPerformanceLevel(partner.totalSales);
                  return (
                    <TableRow key={partner.id} sx={{ '&:hover': { backgroundColor: '#f5f5f5' } }}>
                      <TableCell>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                          <Avatar sx={{ bgcolor: 'primary.main', width: 40, height: 40 }}>
                            {partner.partnerName.charAt(0)}
                          </Avatar>
                          <Box>
                            <Typography variant="body2" fontWeight="700">{partner.partnerName}</Typography>
                            <Typography variant="caption" color="text.secondary" sx={{ fontFamily: 'monospace' }}>
                              {partner.partnerCode}
                            </Typography>
                            <Typography variant="caption" color="text.secondary" display="block">
                              <OwnerIcon sx={{ fontSize: 12, mr: 0.5 }} />
                              {partner.ownerName}
                            </Typography>
                          </Box>
                        </Box>
                      </TableCell>
                      <TableCell>
                        <Chip 
                          label={partner.partnerType} 
                          size="small" 
                          color={getTypeColor(partner.partnerType)}
                          sx={{ fontWeight: 600, mb: 0.5 }}
                        />
                        <Typography variant="caption" display="block" color="text.secondary">
                          {partner.commissionRate}% Commission
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Box>
                          <Typography variant="caption" display="flex" alignItems="center" sx={{ mb: 0.5 }}>
                            <PhoneIcon sx={{ fontSize: 14, mr: 0.5 }} />
                            {partner.phone}
                          </Typography>
                          <Typography variant="caption" display="flex" alignItems="center" sx={{ mb: 0.5 }}>
                            <EmailIcon sx={{ fontSize: 14, mr: 0.5 }} />
                            {partner.email.substring(0, 20)}...
                          </Typography>
                          <Typography variant="caption" display="flex" alignItems="center">
                            <LocationIcon sx={{ fontSize: 14, mr: 0.5 }} />
                            {partner.city}, {partner.state}
                          </Typography>
                        </Box>
                      </TableCell>
                      <TableCell>
                        <Box>
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.5 }}>
                            <Typography variant="body2" fontWeight="700" color="secondary.main">
                              {formatCurrency(partner.totalSales)}
                            </Typography>
                            <Chip 
                              label={performance.label} 
                              size="small" 
                              color={performance.color}
                              sx={{ height: 18, fontSize: '0.65rem' }}
                            />
                          </Box>
                          <Typography variant="caption" color="text.secondary">
                            Orders: {partner.totalOrders} • Avg: {formatCurrency(partner.avgOrderValue)}
                          </Typography>
                          <LinearProgress 
                            variant="determinate" 
                            value={Math.min((partner.totalSales / 1000000) * 100, 100)}
                            sx={{ mt: 0.5, height: 4, borderRadius: 1 }}
                            color={performance.color}
                          />
                        </Box>
                      </TableCell>
                      <TableCell>
                        <Box>
                          <Typography variant="body2" fontWeight="700" color="warning.main">
                            {formatCurrency(partner.totalCommission)}
                          </Typography>
                          <Typography variant="caption" color="success.main">
                            Paid: {formatCurrency(partner.paidCommission)}
                          </Typography>
                          <Typography variant="caption" color="error.main" display="block">
                            Due: {formatCurrency(partner.outstandingCommission)}
                          </Typography>
                        </Box>
                      </TableCell>
                      <TableCell>
                        <Chip
                          label={partner.kycStatus}
                          size="small"
                          sx={{
                            backgroundColor: kycStyle.bg,
                            color: kycStyle.color,
                            fontWeight: 600,
                            mb: 0.5,
                          }}
                        />
                        {partner.bankVerified && (
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                            <BankIcon sx={{ fontSize: 12, color: 'success.main' }} />
                            <Typography variant="caption" color="success.main">Bank ✓</Typography>
                          </Box>
                        )}
                      </TableCell>
                      <TableCell>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                          <StarIcon sx={{ fontSize: 16, color: '#ffc107' }} />
                          <Typography variant="body2" fontWeight="600">
                            {partner.rating}
                          </Typography>
                        </Box>
                        <Typography variant="caption" color="text.secondary">
                          {partner.activeCustomers} customers
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Chip
                          label={partner.status}
                          size="small"
                          sx={{
                            backgroundColor: 
                              partner.status === 'Active' ? '#e8f5e9' : 
                              partner.status === 'Pending Approval' ? '#fff3e0' : '#ffebee',
                            color: 
                              partner.status === 'Active' ? '#2e7d32' : 
                              partner.status === 'Pending Approval' ? '#e65100' : '#d32f2f',
                            fontWeight: 600,
                            mb: 0.5,
                          }}
                        />
                        <Typography variant="caption" color="text.secondary" display="block">
                          Since: {formatDate(partner.registrationDate)}
                        </Typography>
                      </TableCell>
                      <TableCell align="center">
                        <Tooltip title="More Actions">
                          <IconButton 
                            size="small" 
                            onClick={(e) => handleMenuOpen(e, partner)}
                            sx={{ color: 'primary.main' }}
                          >
                            <MoreIcon />
                          </IconButton>
                        </Tooltip>
                      </TableCell>
                    </TableRow>
                  );
                })
              ) : (
                <TableRow>
                  <TableCell colSpan={9} align="center" sx={{ py: 4 }}>
                    <PartnerIcon sx={{ fontSize: 48, color: 'text.disabled', mb: 1 }} />
                    <Typography variant="body1" color="text.secondary">No partners found</Typography>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          component="div"
          count={filteredPartners.length}
          page={page}
          onPageChange={handleChangePage}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          rowsPerPageOptions={[5, 10, 25, 50, 100]}
        />
      </Paper>

      {/* Actions Menu */}
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
      >
        <MenuItem onClick={() => handleView(selectedPartner)}>
          <ListItemIcon>
            <ViewIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>View Details</ListItemText>
        </MenuItem>
        <MenuItem onClick={handleMenuClose}>
          <ListItemIcon>
            <EditIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Edit Partner</ListItemText>
        </MenuItem>
        <MenuItem onClick={handleMenuClose}>
          <ListItemIcon>
            <PerformanceIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>View Performance</ListItemText>
        </MenuItem>
        <MenuItem onClick={handleMenuClose}>
          <ListItemIcon>
            <PaymentIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Pay Commission</ListItemText>
        </MenuItem>
        <Divider />
        {selectedPartner?.status === 'Active' ? (
          <MenuItem onClick={() => handleDeactivate(selectedPartner)}>
            <ListItemIcon>
              <BlockIcon fontSize="small" color="warning" />
            </ListItemIcon>
            <ListItemText>Deactivate</ListItemText>
          </MenuItem>
        ) : (
          <MenuItem onClick={() => handleActivate(selectedPartner)}>
            <ListItemIcon>
              <ActivateIcon fontSize="small" color="success" />
            </ListItemIcon>
            <ListItemText>Activate</ListItemText>
          </MenuItem>
        )}
        <MenuItem onClick={() => handleDelete(selectedPartner)}>
          <ListItemIcon>
            <DeleteIcon fontSize="small" color="error" />
          </ListItemIcon>
          <ListItemText>Delete</ListItemText>
        </MenuItem>
      </Menu>

      {/* View Partner Details Modal */}
      <Dialog open={openViewModal} onClose={() => setOpenViewModal(false)} maxWidth="md" fullWidth>
        <DialogTitle sx={{
          backgroundColor: 'primary.main',
          color: 'white',
        }}>
          <Typography variant="h6" sx={{ color: 'white', display: 'flex', alignItems: 'center', gap: 1 }}>
            <InfoIcon /> Partner Details
          </Typography>
        </DialogTitle>
        <DialogContent sx={{ mt: 2 }}>
          {viewingPartner && (
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
                  <Avatar sx={{ bgcolor: 'primary.main', width: 64, height: 64, fontSize: '1.75rem' }}>
                    {viewingPartner.partnerName.charAt(0)}
                  </Avatar>
                  <Box sx={{ flex: 1 }}>
                    <Typography variant="h5" fontWeight="bold">{viewingPartner.partnerName}</Typography>
                    <Box sx={{ display: 'flex', gap: 1, mt: 0.5, flexWrap: 'wrap' }}>
                      <Chip label={viewingPartner.partnerCode} size="small" sx={{ fontFamily: 'monospace' }} />
                      <Chip label={viewingPartner.partnerType} size="small" color={getTypeColor(viewingPartner.partnerType)} />
                      <Chip label={viewingPartner.status} size="small" color="success" />
                      <Chip 
                        icon={<StarIcon />}
                        label={`${viewingPartner.rating} Rating`} 
                        size="small" 
                        sx={{ bgcolor: '#fff3e0', color: '#e65100' }}
                      />
                    </Box>
                  </Box>
                </Box>
              </Grid>

              {/* Performance Overview */}
              <Grid item xs={12}>
                <Typography variant="subtitle2" fontWeight="bold" gutterBottom>Performance Overview</Typography>
                <Divider sx={{ mb: 2 }} />
              </Grid>
              <Grid item xs={12} sm={4}>
                <Paper sx={{ p: 2, bgcolor: 'rgba(156, 39, 176, 0.05)', textAlign: 'center' }}>
                  <SalesIcon sx={{ fontSize: 32, color: 'secondary.main', mb: 1 }} />
                  <Typography variant="caption" color="text.secondary">Total Sales</Typography>
                  <Typography variant="h5" fontWeight="bold" color="secondary.main">
                    {formatCurrency(viewingPartner.totalSales)}
                  </Typography>
                  <Typography variant="caption" color="text.secondary">
                    Monthly: {formatCurrency(viewingPartner.monthlySales)}
                  </Typography>
                </Paper>
              </Grid>
              <Grid item xs={12} sm={4}>
                <Paper sx={{ p: 2, bgcolor: 'rgba(255, 152, 0, 0.05)', textAlign: 'center' }}>
                  <CommissionIcon sx={{ fontSize: 32, color: 'warning.main', mb: 1 }} />
                  <Typography variant="caption" color="text.secondary">Total Commission</Typography>
                  <Typography variant="h5" fontWeight="bold" color="warning.main">
                    {formatCurrency(viewingPartner.totalCommission)}
                  </Typography>
                  <Typography variant="caption" color="text.secondary">
                    Rate: {viewingPartner.commissionRate}%
                  </Typography>
                </Paper>
              </Grid>
              <Grid item xs={12} sm={4}>
                <Paper sx={{ p: 2, bgcolor: 'rgba(76, 175, 80, 0.05)', textAlign: 'center' }}>
                  <PerformanceIcon sx={{ fontSize: 32, color: 'success.main', mb: 1 }} />
                  <Typography variant="caption" color="text.secondary">Total Orders</Typography>
                  <Typography variant="h5" fontWeight="bold" color="success.main">
                    {viewingPartner.totalOrders}
                  </Typography>
                  <Typography variant="caption" color="text.secondary">
                    Avg: {formatCurrency(viewingPartner.avgOrderValue)}
                  </Typography>
                </Paper>
              </Grid>

              {/* Contact & Business Info */}
              <Grid item xs={12}>
                <Typography variant="subtitle2" fontWeight="bold" gutterBottom>Contact & Business Details</Typography>
                <Divider sx={{ mb: 2 }} />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Paper sx={{ p: 2, bgcolor: '#f5f5f5' }}>
                  <Typography variant="caption" color="text.secondary">Owner Name</Typography>
                  <Typography variant="body1" fontWeight="600">{viewingPartner.ownerName}</Typography>
                </Paper>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Paper sx={{ p: 2, bgcolor: '#f5f5f5' }}>
                  <Typography variant="caption" color="text.secondary">Phone Number</Typography>
                  <Typography variant="body1" fontWeight="600">{viewingPartner.phone}</Typography>
                </Paper>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Paper sx={{ p: 2, bgcolor: '#f5f5f5' }}>
                  <Typography variant="caption" color="text.secondary">Email Address</Typography>
                  <Typography variant="body1" fontWeight="600">{viewingPartner.email}</Typography>
                </Paper>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Paper sx={{ p: 2, bgcolor: '#f5f5f5' }}>
                  <Typography variant="caption" color="text.secondary">Location</Typography>
                  <Typography variant="body1" fontWeight="600">{viewingPartner.city}, {viewingPartner.state}</Typography>
                </Paper>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Paper sx={{ p: 2, bgcolor: '#f5f5f5' }}>
                  <Typography variant="caption" color="text.secondary">GST Number</Typography>
                  <Typography variant="body1" fontWeight="600" sx={{ fontFamily: 'monospace' }}>
                    {viewingPartner.gstNumber || 'Not Provided'}
                  </Typography>
                </Paper>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Paper sx={{ p: 2, bgcolor: '#f5f5f5' }}>
                  <Typography variant="caption" color="text.secondary">Sponsor</Typography>
                  <Typography variant="body1" fontWeight="600">{viewingPartner.sponsorName}</Typography>
                </Paper>
              </Grid>

              {/* Financial Summary */}
              <Grid item xs={12}>
                <Typography variant="subtitle2" fontWeight="bold" gutterBottom>Financial Summary</Typography>
                <Divider sx={{ mb: 2 }} />
              </Grid>
              <Grid item xs={12} sm={4}>
                <Paper sx={{ p: 2, bgcolor: 'rgba(255, 152, 0, 0.05)' }}>
                  <Typography variant="caption" color="text.secondary">Commission Earned</Typography>
                  <Typography variant="h6" fontWeight="bold" color="warning.main">
                    {formatCurrency(viewingPartner.totalCommission)}
                  </Typography>
                </Paper>
              </Grid>
              <Grid item xs={12} sm={4}>
                <Paper sx={{ p: 2, bgcolor: 'rgba(76, 175, 80, 0.05)' }}>
                  <Typography variant="caption" color="text.secondary">Commission Paid</Typography>
                  <Typography variant="h6" fontWeight="bold" color="success.main">
                    {formatCurrency(viewingPartner.paidCommission)}
                  </Typography>
                </Paper>
              </Grid>
              <Grid item xs={12} sm={4}>
                <Paper sx={{ p: 2, bgcolor: 'rgba(244, 67, 54, 0.05)' }}>
                  <Typography variant="caption" color="text.secondary">Outstanding</Typography>
                  <Typography variant="h6" fontWeight="bold" color="error.main">
                    {formatCurrency(viewingPartner.outstandingCommission)}
                  </Typography>
                </Paper>
              </Grid>
            </Grid>
          )}
        </DialogContent>
        <DialogActions sx={{ p: 2.5 }}>
          <Button onClick={() => setOpenViewModal(false)}>Close</Button>
          <Button variant="contained" startIcon={<PaymentIcon />}
            sx={{
              backgroundColor: 'primary.main',
              '&:hover': { backgroundColor: 'primary.dark' },
            }}
          >
            Pay Commission
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default PartnerList;

